import SelectBanks from './select-banks';

export default SelectBanks;
